import { Navigation, NavigationProvider } from 'features/navigation';
import { memo } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

function Layout() {
    return (
        <NavigationProvider>
            <Root>
                <Navigation />

                <Content>
                    <Outlet />
                </Content>
            </Root>
        </NavigationProvider>
    );
}

const Root = styled.main`
    min-height: 100dvh;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: #F5F6F7;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 0;
    background-color: #F5F6F7;
`;

export default memo(Layout);
